export const Constants = {
  TAG_NAME: 'pop-pc-esg-table-component',
  TRANSLATION_KEYS: {
    PROXY_VOTING_SUMMARY: 'tables.esg.headers.proxy_voting_summary',
    CARBON_FOOTPRINT_REPORT: 'tables.esg.headers.carbon_footprint_report',
    ESG_ENGAGEMENT_REPORT: 'tables.esg.headers.esg_engagement_report',
    ANNUAL_IMPACT_REPORT: 'tables.esg.headers.annual_impact_report',
  },
  ESG_COLUMN_IDS: {
    PROXY_VOTING_SUMMARY: 'proxy-voting-summary',
    CARBON_FOOTPRINT_REPORT: 'carbon-footprint-report',
    ESG_ENGAGEMENT_REPORT: 'esg-engagement-report',
    ANNUAL_IMPACT_REPORT: 'annual-impact-report',
  },
  REPORT_ROW_CLASS: 'b-flex b-justify-center',
} as const;
